var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-sub-tag"},[_c('div',{staticClass:"module-sub-tag-name"},[_vm._v(_vm._s(_vm.data.name))]),_vm._v(" "),_c('div',{staticClass:"module-sub-tag-value"},_vm._l((_vm.data.value),function(v,i){return _c('span',{key:i,staticClass:"module-sub-tag-value-item"},[_vm._v("\n      "+_vm._s(_vm.format(v))+"\n    ")])}))])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-011fe40e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/module/sub/Tag.vue
// module id = null
// module chunks = 